import React from "react";

const Delivered = (props) => {
    return (
        <div>
            <div class="container">
                <div class="row">
                    <div className="row customer-support text-center" style={{ marginTop: 10 }}>
                        <h4 style={{ color: "black" }}>{props.VehEntry.Veh_Year} {props.VehEntry.Veh_Make} {props.VehEntry.Veh_Model}</h4>
                        <p style={{ marginTop: 10, color: "black" }}>Delivered</p>
                        <p><b>{props.Veh_Year}</b></p>
                    </div>
                </div>
            </div>
            <div className="sec-title text-left" style={{ marginTop: 10 }}>
                <h4 style={{ color: "black" }}>What does this mean?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>Your vehicle repair has been completed and has been delivered back to you. If you have brought your vehicle back for additional work or re-work under the same repair order, it may not be reflected here.</p>
            </div>
        </div>
    )
}

export default Delivered